import { render, staticRenderFns } from "./BlockType20.vue?vue&type=template&id=af1b863e&scoped=true"
import script from "./BlockType20.vue?vue&type=script&lang=ts"
export * from "./BlockType20.vue?vue&type=script&lang=ts"
import style0 from "./BlockType20.vue?vue&type=style&index=0&id=af1b863e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1b863e",
  null
  
)

export default component.exports